<main>
  <mat-drawer-container class="sidenav-container">
     <mat-drawer #drawer class="sidenav" mode="side" opened>
       <div class="sidenav-content">
         <button type="button" mat-raised-button routerLink="./password">
           Mot de passe
           <!-- {{'password' | translation}}-->
         </button>
       </div>

       <div class="sidenav-content">
         <button type="button" mat-raised-button routerLink="./appfiles">
           Fichiers application
           <!--     {{'appFile' | translation}}-->
         </button>
       </div>
     </mat-drawer>


   </mat-drawer-container>
  <router-outlet></router-outlet>
</main>
